/**
 * Extract a 5-digit postal code from a free-form address string.
 * Supports optional FI- prefix (e.g. FI-80220).
 *
 * @param {string} address
 * @returns {string|null}
 */
export const extractPostalCode = (address) => {
    if (!address || typeof address !== 'string') return null;
    const match = address.match(/\b(?:FI-)?(\d{5})\b/i);
    return match ? match[1] : null;
};

/**
 * Normalize a free-form street address for form prefills.
 * - Fixes common missing space after "c/o"
 * - Inserts missing space before a glued Finnish postal code (e.g. "580220" -> "5 80220")
 * - Strips trailing postal code + city segment, since those are sent as separate fields
 *
 * @param {string} address
 * @returns {string|null}
 */
export const normalizeStreetAddress = (address) => {
    if (!address || typeof address !== 'string') return null;

    let value = address.replace(/\s+/g, ' ').trim();
    value = value.replace(/\bc\/o(?=\S)/gi, 'c/o ');
    value = value.replace(/(\D)(\d)(\d{5})(\b)/g, '$1$2 $3$4');

    const postalMatch = value.match(/\b(?:FI-)?\d{5}\b/i);
    if (postalMatch && typeof postalMatch.index === 'number' && postalMatch.index > 0) {
        value = value.slice(0, postalMatch.index).trim();
    }

    return value || null;
};
